/* Amazon-style sticky add-to-cart behaviour. */
(function () {
  const bar = document.querySelector('[data-amazon-sticky]');
  if (!bar) return;

  const mainSubmit = document.querySelector('.product-form__submit');
  const stickyButton = bar.querySelector('[data-amazon-sticky-add]');

  // Trigger the real product form when the sticky button is clicked.
  if (stickyButton && mainSubmit) {
    stickyButton.addEventListener('click', function () {
      mainSubmit.click();
    });
  }

  // Keep the sticky button label/disabled state in sync with the real one.
  function syncState() {
    if (!mainSubmit || !stickyButton) return;
    stickyButton.disabled = mainSubmit.disabled;
    const text = mainSubmit.querySelector('span');
    if (text) stickyButton.textContent = text.textContent.trim();
  }

  // Show the bar only after the main add-to-cart button leaves the viewport.
  if (mainSubmit && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            bar.setAttribute('hidden', 'hidden');
          } else {
            bar.removeAttribute('hidden');
            syncState();
          }
        });
      },
      { rootMargin: '0px 0px -80px 0px' }
    );
    observer.observe(mainSubmit);
  }
})();
